import { render, staticRenderFns } from "./edit.participant-role.page.vue?vue&type=template&id=a8a07938&"
import script from "./edit.participant-role.page.vue?vue&type=script&lang=js&"
export * from "./edit.participant-role.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports